/*
 * useBelegGui.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-06 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { gql } from 'graphql-tag'
import * as React from 'react'
import toast from 'react-hot-toast'
import { AnyVariables, OperationResult, useMutation } from 'urql'
import { navigate } from 'wouter/use-location'

import { LinkRender } from '../../lib/hd-link'
import { ICommandBarItemProps } from '../../lib/muipanels'

export function useBelegGui(auftrag) {
  const [, mutateEntity] = useMutation(BELEG_CREATE_MUTATION)

  const belegErzeugen = (art: string) => {
    const prom = async () => {
      const r = await mutateEntity({
        designator: auftrag.auftragsnr,
        art,
      })
      if (r.error) throw r.error
      return r
    }
    toast.promise(prom(), {
      loading: `Erzeuge ${art}`,
      success: (r: OperationResult<any, AnyVariables>) => {
        navigate(`/belege/${r?.data?.updateHwAuftragBelegZufuegen}/`)
        return (
          <React.Fragment>
            Beleg <LinkRender value={r?.data?.updateHwAuftragBelegZufuegen} /> erstellt.
          </React.Fragment>
        )
      },
      error: (r: OperationResult<any, AnyVariables>) => {
        console.error(r?.error)
        return `Fehler: ${r?.error?.message}`
      },
    })
  }

  const kannBelegZufuegen = auftrag.status >= '100ready'
  const item: ICommandBarItemProps = {
    key: 'neuerbeleg',
    text: 'Beleg Erstellen',
    ariaLabel: 'Auftragsbeleg Erstellen',
    iconOnly: false,
    iconProps: { iconName: 'DocumentSet' },
    disabled: !kannBelegZufuegen,
    // onClick: () => openPanel(),
    subMenuProps: {
      items: [
        {
          key: 'Bestellbestätigung',
          text: 'Bestellbestätigung - unverbindlich',
          iconProps: { iconName: 'TextDocument' },
          onClick: () => belegErzeugen('Bestellbestätigung'),
        },
        {
          key: 'Auftragsbestätigung',
          text: 'Auftragsbestätigung - Auftragsnannahme',
          iconProps: { iconName: 'Boards' },
          onClick: () => belegErzeugen('Auftragsbestätigung'),
        },
        {
          key: 'Proformarechnung',
          text: 'Proformarechnung - Vorauskassewunsch',
          iconProps: { iconName: 'M365InvoicingLogo' },
          onClick: () => belegErzeugen('Proformarechnung'),
        },
        {
          key: 'Zollrechnung',
          text: 'Zollrechnung - mit Gewichten etc.',
          iconProps: { iconName: 'DocumentSearch' },
          onClick: () => belegErzeugen('Zollrechnung'),
        },
        {
          key: 'Auftragsstatus',
          text: 'Auftragsstatus - Information',
          iconProps: { iconName: 'Mail' },
          onClick: () => belegErzeugen('Auftragsstatus'),
        },
      ],
    },
  }
  return [item]
}

const BELEG_CREATE_MUTATION = gql`
  mutation BelegZufuegenMutation($designator: String!, $art: String!) {
    updateHwAuftragBelegZufuegen(designator: $designator, art: $art)
  }
`
